import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth, formatApiError } from "@/lib/auth";

export default function Register() {
  const { register, startGoogle } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [busy, setBusy] = useState(false); const [err, setErr] = useState(null);
  const submit = async (e) => {
    e.preventDefault(); setBusy(true); setErr(null);
    try { await register(form.email, form.password, form.name); nav("/"); }
    catch (e) { setErr(formatApiError(e.response?.data?.detail) || e.message); }
    finally { setBusy(false); }
  };
  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0c0a09] px-4" data-testid="register-page">
      <div className="w-full max-w-md">
        <div className="mb-8 text-center">
          <div className="text-[10px] font-mono uppercase tracking-[0.3em] text-orange-500/80">Executive Assistant</div>
          <h1 className="font-serif text-5xl mt-2 tracking-tight text-stone-50">Copilot</h1>
        </div>
        <form onSubmit={submit} className="border border-stone-800 bg-[#1c1917] p-8 space-y-4">
          <h2 className="text-xl font-serif text-stone-100">Create your account</h2>
          <input data-testid="reg-name" placeholder="Your name" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })}
            className="w-full bg-stone-900 border border-stone-800 px-3 py-2.5 text-sm text-stone-100 focus:border-orange-600 outline-none"/>
          <input data-testid="reg-email" type="email" placeholder="Email" required value={form.email}
            onChange={(e) => setForm({ ...form, email: e.target.value })}
            className="w-full bg-stone-900 border border-stone-800 px-3 py-2.5 text-sm text-stone-100 focus:border-orange-600 outline-none"/>
          <input data-testid="reg-password" type="password" placeholder="Password (8+ chars)" required minLength={8}
            value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })}
            className="w-full bg-stone-900 border border-stone-800 px-3 py-2.5 text-sm text-stone-100 focus:border-orange-600 outline-none"/>
          {err && <div className="text-xs text-red-400 font-mono" data-testid="reg-error">{err}</div>}
          <button data-testid="reg-submit" type="submit" disabled={busy}
            className="w-full bg-orange-600 hover:bg-orange-500 disabled:bg-stone-800 text-white text-xs uppercase tracking-widest font-mono py-2.5 transition-colors">
            {busy ? "…" : "Create account"}
          </button>
          <div className="text-[10px] uppercase tracking-widest font-mono text-stone-500 text-center">or</div>
          <button data-testid="reg-google" type="button" onClick={startGoogle}
            className="w-full border border-stone-700 hover:border-stone-500 text-stone-100 text-xs uppercase tracking-widest font-mono py-2.5 transition-colors">
            Continue with Google
          </button>
          <div className="text-xs text-stone-500 text-center pt-2">
            Already have an account? <Link data-testid="link-login" to="/login" className="text-orange-500 hover:underline">Sign in</Link>
          </div>
        </form>
      </div>
    </div>
  );
}
